import c from 'classnames';
import { useCallback } from 'react';

export default function useClasses(
  blockClass: string,
  ...modifiers: c.ArgumentArray
) {
  const buildClass = useCallback(
    (element?: string, ...elementModifiers: c.ArgumentArray) => {
      if (!element) {
        return c(blockClass, attachModifiers(blockClass, modifiers));
      }

      const elementClass = `${blockClass}__${element}`;

      return c(elementClass, attachModifiers(elementClass, elementModifiers));
    },
    [blockClass, modifiers],
  );

  return {
    buildClass,
    joinClasses: c,
  } as const;
}

function attachModifiers(mainClass: string, ...modifiers: c.ArgumentArray) {
  return c(modifiers)
    .split(' ')
    .filter((value) => value.length)
    .map((modifier) => `${mainClass}--${modifier}`)
    .join(' ');
}
